"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.DeniedIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { fill: "#e8595a", d: "M8,1a7,7,0,1,0,7,7A7,7,0,0,0,8,1ZM3,8a4.969,4.969,0,0,1,.833-2.753l6.92,6.92A4.992,4.992,0,0,1,3,8Zm9.167,2.753-6.92-6.92a4.992,4.992,0,0,1,6.92,6.92Z" }))); };
//# sourceMappingURL=DeniedIcon.js.map